import { makeStyles } from "@material-ui/styles";

const startImportContainerStyles = makeStyles((theme) => ({
	detailsContainer: {
		margin: "auto",
		display: "flex",
		justifyContent: "center",
		padding: theme.spacing(0, 4)
	},
	pre: {
		width: "100%",
		height: 200,
		padding: 10,
		borderRadius: 3,
		backgroundColor: theme.palette.secondary.main
	}
}));

export default startImportContainerStyles;
